// extracted by mini-css-extract-plugin
module.exports = {"container":"WinnerSection_container__H31bN","textMaxWidth":"WinnerSection_textMaxWidth__K1SKG"};